export default __webpack_public_path__ + "static/media/grocery7.b40c25aa.jpeg";